"use strict";

import { GET_MANAGED_TEAMS } from "../ApiEndpoints";
import apiClient from "./apiClient";

export const fetchManagedTeams = async ({ requesterUserId } = {}) => {
    const response = await apiClient.get(GET_MANAGED_TEAMS, {
        params: requesterUserId ? { requester_user_id: requesterUserId } : undefined,
    });

    return Array.isArray(response.data?.teams) ? response.data.teams : [];
};
